import { render } from "./ScrollDown.vue?vue&type=template&id=3f887323&scoped=true"
import script from "./ScrollDown.vue?vue&type=script&lang=js"
export * from "./ScrollDown.vue?vue&type=script&lang=js"

import "./ScrollDown.vue?vue&type=style&index=0&id=3f887323&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f887323"]])

export default __exports__